import Raven from 'raven-js';

// http://www.rubular.com/r/f7czsmE0yi
Raven.config(process.env.SENTRY_PUBLIC_DSN, {
  whitelistUrls: [/(staging.)?linkinprofile\.com\/packs\/\w*-[a-zA-Z0-9_.-]*\.js/],
  environment: process.env.DEPLOYMENT,
}).install();

export default Raven;
